import React from "react";
import "./teachers.css";
import { Link } from "react-router-dom";

function TeachersTraining() {
  return (
    <div className="teachers-training-page">

      {/* Banner Section */}
      <section className="teachers-banner-section">
        <img src="/trainingsbanner.png" alt="Teachers Banner" className="teachers-banner-img" />
        <div className="teachers-banner-overlay">
          <h1>Teachers Training Program</h1>
          <p>
            Join our Teachers Training Program to enhance teaching skills, inspire learning, and promote better educational practices in schools.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="teachers-description-section">
        <div className="teachers-text">
          <h2>About Teachers Training Program</h2>
          <p>
           The Teachers Training Program equips educators with the skills to promote eye health awareness
            and early detection of vision problems among students. Through 5 step approach education, 
            early intervention, and follow up teachers learn how to identify warning signs, provide guidance.
             This initiative empowers teachers to protect children’s
             vision, fostering better learning outcomes and long term eye health.
          </p>
        </div>
        <div className="teachers-image">
          <img src="/teach-training.jpg" alt="Teachers Training" />
        </div>
      </section>

      {/* Recent Program Gallery */}
      <section className="teachers-held-programme-wrapper">
        <div className="teachers-held-programme-header">
          <h1>Recent Teachers Training Sessions</h1>
            <p>
            Explore our recent Teachers Training workshops, where educators learned the 5-step eye care awareness approach to help detect vision problems early in students.
            </p>
        </div>
{/* 
        <div className="teachers-held-programme-gallery">
          <img src="/teacher1.jpg" alt="Teachers Training 1" />
          <img src="/teacher2.jpg" alt="Teachers Training 2" />
          <img src="/teacher3.jpg" alt="Teachers Training 3" />
          <img src="/teacher4.jpg" alt="Teachers Training 4" />
          <img src="/teacher5.jpg" alt="Teachers Training 5" />
          <img src="/teacher6.jpg" alt="Teachers Training 6" />
          <img src="/teacher7.jpg" alt="Teachers Training 7" />
          <img src="/teacher8.jpg" alt="Teachers Training 8" />
          <img src="/teacher9.jpg" alt="Teachers Training 9" />
          <img src="/teacher10.jpg" alt="Teachers Training 10" />
          <img src="/teacher11.jpg" alt="Teachers Training 11" />
          <img src="/teacher12.jpg" alt="Teachers Training 12" />
        </div> */}
      </section>

      {/* Footer Section */}
      <section className="teachers-footer-section">
        <div className="teachers-footer-content">
            <h2>Empower Eye Health in Everywhere</h2>
            <p>
            Join us in shaping a brighter future by equipping teachers with essential skills to promote eye health, detect vision issues early, and protect children’s sight.
            </p>
          <Link to="/contactus">
            <button className="teachers-footer-button">Get Involved</button>
          </Link>
        </div>
      </section>

    </div>
  );
}

export default TeachersTraining;
